import products from '@/storage/products'
import stores from '@/storage/stores'
import { getStore } from '@/utils/getStore'
import { ref } from 'vue'
import { getProductToCategory } from './getProductToCategory'
import { dataLoaded } from '@/event/dataLoaded'
import { isThemeDefault } from '@/event/theme/theme'
import { isNavbarVisible } from '@/event/isNavbarVisible'
import { isLoading } from '@/event/error/isLoading'

const categoryIds = ref()
const catalogueBase = ref()

export async function loadData() {
  isLoading.value = true

  try {
    let storeData = stores.getStoresData()
    if (!storeData || !storeData.store_id) {
      await getStore()
    }

    storeData = stores.getStoresData()

    if (storeData && storeData.category) {
      catalogueBase.value = storeData.category
      if (catalogueBase.value.length > 0) {
        categoryIds.value = catalogueBase.value.map(
          (category: { category_id: any }) => category.category_id
        )
      }

      if (products.getProductData().length === 0) {
        await getProductToCategory(categoryIds.value)
      }

      if (storeData.category && storeData.category.length !== 0) {
        for (const category of storeData.category) {
          const productsInCategory = products.getProductData().filter(
            (product: { category_id: number }) => product.category_id === category.category_id
          );

          if (productsInCategory.length === 0 && storeData.category) {
            stores.getStoresData().category = stores.state.storeData.category?.filter(
              (cat) => cat.category_id !== category.category_id
            );
          } else {
            const allShippingOne = productsInCategory.every((product: any) => product.shipping === 1);

            if (allShippingOne) {
              stores.state.storeData.category = stores.state.storeData.category?.filter(
                (cat) => cat.category_id !== category.category_id
              );
            }
          }
        }
      }

      dataLoaded.value = 2

      if (isThemeDefault.value) {
        isNavbarVisible.value = true
      }
    }
  } catch (e) {
    dataLoaded.value = 1
    isLoading.value = false
  }
}